export const ENTITIES = {
    assistants: 'assistants',
    consuls: 'consuls',
    districts: 'districts',
    sympathizers: 'sympathizers',
    socialNetworksTags: 'socialNetworksTags',
    files: 'files',
    folders: 'folders'
}